import { createStore, applyMiddleware, Store} from 'redux';
import { rootReducer } from './reducers/root';
import apiMiddleware from './middleware/api';
import thunk from "redux-thunk";
// import logger from 'redux-logger';

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const composeEnhancers = compose;

const middleware = [apiMiddleware, thunk];

// if (process.env.NODE_ENV !== 'production') {
//     middleware = [...middleware, logger];
// } else {
//     middleware = [...middleware];
// }

const store: Store = createStore(
    rootReducer, applyMiddleware(...middleware)
);

// window.store = store; // makes the store available globally

const onStoreChange = () => {
    // console.log(store.getState())
};
store.subscribe(onStoreChange);

export default store;
